<template>
  <DetailPage
    :detailData="data"
    :detailKind="detailKind"
  />
</template>
<script setup>
import { fetchNews } from '/api/admin';
import { errorCommon } from '/api/common';
const detailKind = 'news';
const { params } = useRoute();
const { id } = params;

const { data } = await useAsyncData('news-detail', () => fetchNews(id).catch(errorCommon), {
  default: () => {},
});
const route = useRoute();
const ogImg = computed(() => {
  return data.value.thumbnail
    ? data.value.thumbnail
    : 'https://t1.kakaocdn.net/dkt_corp/service/og_img.png';
});

useHead({
  title: `${data.value.title} | 뉴스 - dk techin`,
  meta: [
    { property: 'og:title', content: `${data.value.title} | 뉴스 - dk techin` },
    { property: 'og:image', content: `${ogImg.value}` },
    { property: 'og:url', content: `https://dktechin.com${route.fullPath}` },
  ],
});
</script>
